import '../assets/css/Font.css';

const FooterComp = () => {
  return(
    <div>
      <p className="font-footer">
        이메일: sjk.dedos@gmail.com<br />
        github: ssimdedos<br />
      </p>
    </div>
  );
};

export default FooterComp;